import { RequestOptions } from '@plus-int/acq-toolkit';
import { getGeoReplacementHeaders } from '@funtech-int/i18n-geo-widget/sdk';
import { fromBrowser } from '@funtech-int/i18n-geo-widget/sdk/fromBrowser';
import type { RequestIdManager } from '@funtech-int/yango-shared';
import { createFetcher, type FetcherMiddleware } from '@funtech-int/web-toolkit';

import { Environment } from '@kinopoisk-int/kp-environment';
import { RequestIdsHeader } from '@kinopoisk-int/request-ids';
import type { Logger } from '@kinopoisk-int/logger';

import { fetcherLoggingMiddleware } from './fetcherMiddlewares';

export function createOffersRequester(
    requestIdManager: RequestIdManager,
    logger: Logger,
    middlewares: FetcherMiddleware[] = []
) {
    const fetcher = createFetcher({ credentials: 'include' }, [
        fetcherLoggingMiddleware(logger, 'browser-offers-client'),
        ...middlewares,
    ]);

    return function offersRequester<T>({ url, headers, ...rest }: RequestOptions): Promise<T> {
        return fetcher
            .fetch(url, {
                ...rest,
                headers: {
                    ...headers,
                    ...getGeoReplacementHeaders(fromBrowser),
                    [RequestIdsHeader.RequestId]: requestIdManager.requestId.child,
                    [RequestIdsHeader.Traceparent]: requestIdManager.traceparent,
                },
            })
            .then((response) => {
                if (!response.ok) {
                    logger.error(
                        { url, status: response.status, statusText: response.statusText },
                        `HTTP ${response.status} ${response.statusText} for ${url}`
                    );
                }

                return response.json();
            });
    };
}

export function getPlusPaymentEnvironment(
    environment: Environment
): 'production' | 'prestable' | 'testing' {
    if (environment === Environment.Production) {
        return 'production';
    }
    if (environment === Environment.Prestable) {
        return 'prestable';
    }
    return 'testing';
}
